import type { PiniaPlugin } from 'pinia';
import { isProdEnvironment } from '@/settings/environment.utils.js';
// Namespace import keeps reads live: sessionTracker is a `let` export reassigned by initializeSessionTracker
import * as sessionActivityUtil from '@utils/session/session-activity.util';

export const sessionPlugin: PiniaPlugin = ({ store }) => {
    if (window.Cypress) return;

    if (store.$id === 'subscription') {
        store.$onAction(({ name, after }) => {
            if (name !== 'setActive' && name !== 'setActiveById') return;

            after(() => {
                const inactivityThreshold = Number(store.active.maxSessionInactivity);
                if (sessionActivityUtil.sessionTracker?.inactivityThreshold !== inactivityThreshold) {
                    setupTracker(inactivityThreshold);
                }
            });
        });
    }

    if (store.$id === 'auth') {
        store.$onAction(({ name, args, after }) => {
            if (name === 'logout') {
                disposeTracker();

                return;
            }
            if (name !== 'setAuthenticated' || (args[0] as { authenticated?: boolean })?.authenticated) return;
            after(disposeTracker);
        });
    }
};

export function setupTracker (inactivityThreshold: number): void {
    if (window.Cypress) return;

    if (sessionActivityUtil.sessionTracker) {
        sessionActivityUtil.sessionTracker.dispose();
    }

    sessionActivityUtil.initializeSessionTracker({ inactivityThreshold });
}

function disposeTracker (): void {
    if (!sessionActivityUtil.sessionTracker) return;

    try {
        sessionActivityUtil.sessionTracker.dispose();
    } catch (error) {
        if (!isProdEnvironment()) {
            // eslint-disable-next-line no-console
            console.warn('Issue setting up session activity with error', error);
        }
    }
}
